<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            <CButton color="success" @click="newScreen" class="float-right">
              <CIcon name="cilPlus" />
              New Screen
            </CButton>
            <h4>Screens</h4>

          </CCardHeader>
          <CCardBody>
            <CAlert color="secondary" closeButton>
              <CIcon name="cil-lightbulb"/>
              <span class="pl-2">Screens consist of a collection of different blocks that are displayed on a single screen in the app.</span>
            </CAlert>
            <CAlert color="danger" v-if="missingScreens">
              {{missingScreens}}
            </CAlert>
            <CDataTable
              hover
              striped
              table-filter
              :items="items"
              :fields="fields"
              clickable-rows
              @row-clicked="rowClicked"
              :items-per-page="10"
              :active-page="activePage"
              :pagination="{ doubleArrows: false, align: 'center'}"
              @page-change="pageChange"
              :loading="isLoading"
            >
             <template #edit="">
                <td>
                  <CIcon name="cil-arrow-right" />
                </td>
              </template>
              <template slot="no-items-view" v-if="isLoading">
                <span>Loading items</span>
              </template> 
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Screens',
  data () {
    return {
      items: [],
      fields: [
        { key: 'id'},
        { key: 'label', 'label': 'Sceen label', _classes: 'font-weight-bold' },
        { key: 'name' , 'label': 'Name'},
        { key: 'asset_name', 'label': 'Icon' },
        { key: 'edit', label: ' ' },
      ],
      activePage: 1,
      isLoading: false,
      settings: this.$settings,
      all_screens: [],
    }
  },
  computed: {

    missingScreens() {
      let missing = false
      let str = "The system expects a few specific screen names to exist. Please make sure to configure these. "
      this.settings["required_screen_names"].forEach((screen) => {
        if (!this.all_screens.includes(screen)) {
          missing = true
          str += "A screen with screen name `" + screen + "` is required. "
        }
      })
      if (missing) {
        return str
      } else {
        return false
      }
    },
    ...mapState({
      warningLocation: state => state.warning ? state.warning.location : null,
    }),
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    rowClicked (item) {
      const screenId = `screen-${item.id}`
      const warning = this.$store.getters.checkWarning(screenId)

      if (warning) {
        if (confirm('This will remove the changes you made to your previous screen. Are you sure?')) {
          this.$router.push({ path: `screens/${item.id}` })
        } 
      } else {
        this.$router.push({ path: `screens/${item.id}` })
      }       
    },
    newScreen () {
      const warning = this.$store.getters.checkWarning('screen-0')
      if (warning) {
        if (confirm('This will remove the changes you made to your previous screen. Are you sure?')) {
          this.$router.push({ path: 'screens/0' })
        }
      } else {
        this.$router.push({ path: 'screens/0' })
      }
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
    getData() {
      this.isLoading = true
      this.$api.get('screens/')
      .then((response) => {
        response.data.map((e) => { 
          this.all_screens.push(e.name)
          e.edit = true 
        })
        this.items = response.data
        this.isLoading = false
      })
    }
  }
}
</script>
